<template>
  <el-form-item :label="label" :prop="prop" :class="{'jin-textarea' : type === 'textarea'}">
    <el-input :value="value" :type="type" class="jin-input" :placeholder="placeholder" :rows="5" :maxlength="type === 'textarea' ? 150 : ''" show-word-limit @input="onInput" />
  </el-form-item>
</template>

<script>
export default {
  props: {
    type: {
      type: String,
      default: 'text'
    },
    label: {
      type: String,
      default: ''
    },
    prop: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: '请输入'
    },
    value: {
      type: [String, Number],
      default: ''
    }
  },
  methods: {
    onInput(v) {
      this.$emit('input', v)
    }
  }
}
</script>

<style lang="scss">
.jin-pc {
  .el-form-item {
    width: 320px;
  }

  .el-input {
    // width: 320px !important;
  }

  .jin-textarea {
    width: 100%;
    // flex: 1;
  }

  /deep/ .el-textarea {
    &__inner {
      min-height: 140px !important;
    }
  }
}

.jin-m {
  /deep/ .el-textarea {
    &__inner {
      // min-height: 118px !important;
    }
  }
}
</style>
